import { lazy } from 'react';

export const LocoPage = lazy(() => import('./LocoPage'));
